<template>
    <div
        class="flex border list-group-item bg-white p-4 text-black m-b-lg flex-col items-center rounded"
    >
        <img :src="brand.avatar_url" alt="" class="spark-profile-photo-lg" />
        <h2 class="m-t-sm">
            {{ brand.name }}
        </h2>
        <p class="text-xl font-thin">Ønsker du at deltage i {{ brand.name }}'s ambassadør team?</p>
        <p class="text-gray-600 max-w-md text-center font-thin">
            Ved deltagelse i {{ brand.name }}'s ambassadør team giver du {{ brand.name }}
            tilladelse til at se din betterhype profil, herunder forbundne medier og insights for disse.
        </p>
        <div class="my-4">
            <button
                class="btn btn-primary py-3 px-12 mx-2 font-thin text-base"
                :disabled="form.busy"
                @click="accept"
            >
                Ja tak
            </button>
            <button class="btn btn-default py-3 px-12 mx-2 font-thin text-base" @click="cancel">
                Nej tak
            </button>
        </div>
    </div>
</template>

<style lang="less" type="text/less"></style>

<script type="text/babel">
export default {
    props: ['invitation'],

    data() {
        return {
            form: new SparkForm({}),
        }
    },

    created() {
        this.brand = this.invitation.brand
    },

    methods: {
        accept() {
            Spark.post(this.invitation.url, this.form).then(() => this.$emit('accepted'))
        },

        cancel() {
            this.$emit('declined')
        },
    },
}
</script>
